export default __webpack_public_path__ + "static/media/mafs.3bb50bf0.jpg";